import { useStore } from "hooks/use-store";
import { Gauges } from "./gauges/gauges";
import { Blocks } from "./blocks/blocks";
import { useScreenSize } from "hooks/use-screen-size";
import { useTrackWidget } from "hooks/use-analytics";
import { Toolbar } from "components/toolbar";
import { FuelCurveScreen } from "screens/dashboard/fuel-curve/fuel-curve";
import { DashboardMode } from "types/enums";

export function DashboardScreen() {
  const { aspectRatio } = useScreenSize();
  const dashboardMode = useStore((state) => state.dashboardMode);

  // Extreme aspect ratios can't fit the gauges/chart layouts, so blocks are
  // forced for display only — the selected mode is kept and restored once the
  // aspect ratio allows it again.
  const blocksForced = aspectRatio < 0.65 || aspectRatio > 3;
  const mode = blocksForced ? DashboardMode.Blocks : dashboardMode;

  useTrackWidget(`dashboard.${mode}`);

  return (
    <section className="h-full flex flex-col">
      <Toolbar />
      <div className="h-full flex flex-col overflow-auto">
        {mode === DashboardMode.Gauges && <Gauges />}
        {mode === DashboardMode.Chart && <FuelCurveScreen />}
        {mode === DashboardMode.Blocks && <Blocks />}
      </div>
    </section>
  );
}
